<template>
  <div class="app-top-nav ">
    <div class=" w top">
      <div class="left">
        <h1 class="logo">
          <router-link to="/">

            <img src="../assets/logo-new.png">
          </router-link>
        </h1>
      </div>

      <div class="right">
        <ul>
          <template v-if="userinfo.token">
            <li>
              <!--            <a href="javascript:;"></a>-->

              <router-link to="/userIndex">{{userinfo.username}}</router-link>
            </li>
            <li>
              <a @click="logout()" >退出登录</a>
            </li>


          </template>

          <template v-else>
            <li>
              <a @click="login()">登录 </a>
            </li>
            <li>
              <a @click="register()">注册 </a>
            </li>
          </template>



        </ul>
      </div>

    </div>
  </div>


  <Login ref='login' :loginFormClick="a"></Login>
  <Register ref='register' :registerFormClick="b"></Register>
</template>

<script>

import Login from './Login.vue'
import Register from "./Register";
import {useStore} from "vuex";
import {computed,ref} from "vue";
import {delCookie} from "@/utils/cookie";
import {useRouter} from 'vue-router'


export default {
  components: {
    Login,
    Register
  },
  setup(props) {
    const store = useStore();

    store.dispatch('user/getTokenFromCookie');
    let userinfo = computed(() => {
      return store.state.user.userinfo;
    });




    const router=useRouter()


    let logout = ()=>{
      store.dispatch('user/logout');

      router.push({ path: '/' });
    }

    const a = ref(1)
    const b = ref(1)
    return {userinfo,a,b,logout};
  },
  methods: {
    login(){
      this.a++;
    },
    register(){
      this.b++;
    }
  }
};
</script>

<style lang="less" scoped>
// @import url('../assets/styles/variables.less');
.app-top-nav {
  background-color: #4877E2;

  .top{
    display: flex;
    justify-content: space-between;
    height: 60px;
    line-height: 60px;
    padding: 5px 0;
  }

  .left{

    .logo {
      width: 375px;
      height: 60px;
      background-color: @xtxColor;

      a {
        display: inline-block;
        height: 60px;
        width: 100%;
        img{

          height: 60px;
        }
      }

    }
  }

  .right{
    ul {
      display: flex;

      justify-content: flex-end;

      li {
        a {
          font-size: 12px;
          padding: 0 15px;
          color: #fff;
          border-left: 1px solid #ccc;

          &:hover {
            color: #000;
            cursor: pointer;
          }
        }
      }

      li:nth-child(1) {
        a {
          border-left: 0;
        }
      }
    }
  }

}
</style>